import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {authModule} from './authModule'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    orders: [],
    ratings: [],
    selectedTab: 0,
    allFeedbacksLoaded: false,
    allFeedbacks: [],
    numberOfAllFeedbacks: 0
  },
  plugins: [createPersistedState()],
  getters: {
    getOrders(state) {
      return state.orders;
    },
    getRatings(state) {
      return state.ratings;
    },
    getPresentableOrders(state) {
      return state.orders.map(presenter);
    },
    getAllFeedbacksLoaded(state) {
      return state.allFeedbacksLoaded;
    },
    getAllFeedbacks(state) {
      return state.allFeedbacks;
    },
    getNumberOfAllFeedbacks(state) {
      return state.numberOfAllFeedbacks;
    },
    getSelectedTab(state) {
      return state.selectedTab;
    },
    getPresentableFeedbackData(state) {
      return state.orders.map(presenterFeedback, state.ratings);
    }    
  },
  mutations: {
    setOrders(state, orders) {
      state.orders = orders;
    },
    setAllFeedbacksLoaded(state, allFeedbacksLoaded){
      state.allFeedbacksLoaded = allFeedbacksLoaded
    },
    setAllFeedbacks(state, allFeedbacks) {
      state.allFeedbacks = allFeedbacks;
    },
    setNumberOfAllFeedbacks(state, numberOfAllFeedbacks){
      state.numberOfAllFeedbacks = numberOfAllFeedbacks;
    },
    setSelectedTab(state, selectedTab) {
      state.selectedTab = selectedTab;
    },
    setRatings(state, ratings) {
      state.ratings = ratings
    }
  },
  actions: {
  },
  modules: {
    auth: authModule
  }
})

export default store;


function presenterFeedback(el) {

  let rating = {
    ContractRequestId: '',
    Journey: '',
    Product: '',
    Rating: 0,
    RatingComment: '',
    UserId: '',
  }
    const rawRating = this.find(rating => rating.ContractRequestId === el.id);

  if(rawRating)
  {
    rating = rawRating
  }

  let res = {};
  res.customer = `${el.applicant.title} ${el.applicant.name} ${el.applicant.surname}`
  res.orderId = el.id;
  res.date = new Date(el.request_date);
  res.product = el.products;
  res.street = feedbackStreet(el)
  res.zip = feedbackZip(el)
  res.city = feedbackLocation(el)
  res.phone = el.applicant.phone_number
  res.mail = el.applicant.email
  res.contact_channel = el.applicant.preferred_contact_channel
  res.rate = rating.Rating
  res.comment = rating.RatingComment
  res.review_agreement = el.permissions.perm_customer_satisfaction

  return res;
}

function feedbackStreet(rawData) {
  let installationAddress = '';
  installationAddress = rawData.product_installation_full_address ?
  `${rawData.product_installation_full_address.street} ${rawData.product_installation_full_address.street_number}`  
  :  
  `Neubaugebiet/Straßenname: ${rawData.product_installation_with_plot_number_address.new_building_area_name}`;

  return installationAddress;
}

function feedbackZip(rawData) {
  let installationAddress = '';
  installationAddress = rawData.product_installation_full_address ?
  `${rawData.product_installation_full_address.zip}`  
  :  
  `${rawData.product_installation_with_plot_number_address.zip}`;

  return installationAddress;
}

function feedbackLocation(rawData) {
  let installationAddress = '';
  installationAddress = rawData.product_installation_full_address ?
  `${rawData.product_installation_full_address.city}`  
  :  
  `${rawData.product_installation_with_plot_number_address.location}`

  return installationAddress;
}

function presenter(el) {
  let res = {};
  res.customer = `${el.applicant.name} ${el.applicant.surname}`
  res.orderId = el.id;
  res.date = new Date(el.request_date);
  res.address = installationAddressObject(el)
  res.product = el.product;
  res.note = el.order_note || '';
  res.json = JSON.stringify(el, null, 4);

  return res;
}

function installationAddressObject(rawData) {
  let installationAddress = '';
  installationAddress = rawData.product_installation_full_address ?
  `${rawData.product_installation_full_address.street} ${rawData.product_installation_full_address.street_number}, ${rawData.product_installation_full_address.zip} ${rawData.product_installation_full_address.city}`  
  :  
  `Neubaugebiet/Straßenname: ${rawData.product_installation_with_plot_number_address.new_building_area_name} <br>
   Gemarkung: ${rawData.product_installation_with_plot_number_address.district} <br>
   Flur: ${rawData.product_installation_with_plot_number_address.landing} <br>
   Flurstück: ${rawData.product_installation_with_plot_number_address.plot} <br>
   ${rawData.product_installation_with_plot_number_address.zip}, ${rawData.product_installation_with_plot_number_address.location}`;

return installationAddress;
}